














import { Component, Prop, Vue } from 'vue-property-decorator';
import { GetReactionIcon } from '@/core/reactions/Reactions';
import { ReactionViewObject, ReactionType } from '@/types/apiServerContract';

@Component
export default class Reaction extends Vue {
	@Prop({ required: true, type: Number }) type!: ReactionType;
	@Prop({ required: true, type: Number }) count!: ReactionType;
	@Prop({ required: true, type: Boolean }) active!: ReactionViewObject;
	@Prop({ type: Boolean, default: false }) loading!: boolean;
	@Prop({ type: Boolean }) isLoggedIn!: boolean;

	animating: boolean = false;

	get id() {
	    return 'reaction-' + this.type;
	}

	get reactionIcon() {
	    return GetReactionIcon(this.type);
	}

	react() {
	    if (this.animating || !this.isLoggedIn) return;

	    this.animating = true;
	    this.$emit('reacted', { type: this.type, active: this.active });
	}
}
